export const TemplateBase = () => {
  return (
    <svg
      className="template-page"
      viewBox="0 0 210 297"
      width="100%"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginTop: "20px" }}
    >
      <path
        id="a4-sheet-bg-base"
        stroke="none"
        fill={"rgb(255,255,255)"}
        d="M0 0H210V297H0z"
      ></path>

      <text
        x="105"
        y="35"
        style={{ fill: "#000" }}
        fontFamily="Calibri"
        fontSize="6"
        textAnchor="middle"
      >
        Dome Base Template
      </text>

      <text
        x="105"
        y="45"
        style={{ fill: "#000" }}
        fontFamily="Calibri"
        fontSize="4"
        textAnchor="middle"
      >
        Cut around this dotted line, from cardboard or thick paper.
      </text>

      <text
        x="105"
        y="52"
        style={{ fill: "#000" }}
        fontFamily="Calibri"
        fontSize="4"
        textAnchor="middle"
      >
        Stick the completed shape net onto it to add rigidity.
      </text>

      {/* BASE SHAPE (Decagon) */}
      <g id="BASE_SHAPE">
        <path
          d="M105,89.62 L139.60,100.86 L161.00,130.30 L161.00,166.70 L139.60,196.14 L105,207.38 L70.40,196.14 L49.00,166.70 L49.00,130.30 L70.40,100.86 Z"
          fill="none"
          stroke="#000"
          strokeWidth="0.5"
          strokeDasharray="2,2"
        />
      </g>
    </svg>
  );
};
